"use strict"
import axios from "axios";
import { getRequest, postRequest } from "@/services/RequestService";

export const getEarned = async (extraRequest = null) => {
  const base_route = `/report/summary/customers/earned${extraRequest == null ? '' : `${extraRequest}`}`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const getRedeemed = async (extraRequest = null) => {
  const base_route = `/report/summary/customers/redeemed${extraRequest == null ? '' : `${extraRequest}`}`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const store = async (request) => {
  const base_route = ``;
  const response = await postRequest(base_route, request);
  return response;
}
